module.exports = __webpack_public_path__ + "img/neikan_banner.c131d559.png";